<template>
  <div class="form-field">
    <label v-if="label">{{ label }}</label>
    <div class="content">
      <div v-if="value">{{ value }}</div>
      <div class="upload">
        <input type="file" ref="file" @change="onUploadAudio" />
        <el-button> 选择文件</el-button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.form-field {
  align-items: flex-start;
}
.content {
  > div {
    font-size: 12px;
  }
  .upload {
    position: relative;
    > input {
      position: absolute;
      width: 80px;
      height: 20px;
      opacity: 0;
    }
  }
}
</style>

<script>
import _ from 'lodash';
import upload from 'mixins/upload';
import config from 'utils/config';
import { convertImage } from 'utils/helper';

export default {
  mixins: [upload],
  props: ['value', 'label'],
  data: function() {
    return {
      image: null,
      pending: false,
      failure: false
    };
  },
  beforeDestroy() {
    this.clearItem();
  },
  methods: {
    clearItem() {
      if (this.image) {
        this.image = null;
      }
    },
    onClick() {
      this.$refs.file.click();
    },
    clearFile() {
      this.$refs.file.value = '';
    },
    onUploadAudio(e) {
      const file = e.target.files[0];
      // 检查文件类型和文件大小
      let file_size = false;
      let file_type = false;
      if (file.size > 1024 * 1024) {
        file_size = true;
      } else if (!/audio\/(\w+)/.test(file.type)) {
        file_type = true;
      }

      if (file_type) {
        this.$alert('文件类型有误！', {
          title: '温馨提示',
          customClass: 'alert',
          confirmButtonText: '确定'
        });
      }
      if (file_size) {
        this.$alert('文件大小过大！', {
          title: '温馨提示',
          customClass: 'alert',
          confirmButtonText: '确定'
        });
      }
      if (!file_size && !file_type) {
        this.uploadFile(file).then(url => {
          this.$emit('input', url);
        });
      } else {
        this.clearFile();
      }
    }
  }
};
</script>
